// File: src/pages/AdminDashboard.js
// This page is updated with a new card for Newsletter Management and an improved grid layout.
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function AdminDashboard() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <header className="bg-black shadow-md">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <img src="/Logo.png" alt="R.A.W. Fitness Logo" className="h-12 w-auto" />
            <h1 className="text-xl font-bold text-lime">Admin Dashboard</h1>
          </div>
          <nav>
            <Link to="/" className="text-white hover:text-lime transition duration-300">Back to Site</Link>
          </nav>
        </div>
      </header>
      <main className="container mx-auto px-6 py-8">
        <h2 className="text-3xl font-bold mb-6 text-magenta">Management Sections</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Card for User Management */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold text-lime mb-4">User Management</h3>
            <p className="text-gray-400 mb-4">View, edit, or delete user profiles and details.</p>
            <button className="w-full bg-lime text-black font-bold py-2 px-4 rounded-lg hover:bg-opacity-80 transition duration-300">Manage Users</button>
          </div>
          {/* Card for Content Management */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold text-lime mb-4">Content Management</h3>
            <p className="text-gray-400 mb-4">Upload, edit, or delete news articles and videos.</p>
            <button 
              onClick={() => navigate('/admin/content')}
              className="w-full bg-lime text-black font-bold py-2 px-4 rounded-lg hover:bg-opacity-80 transition duration-300"
            >
              Manage Content
            </button>
          </div>
          {/* Card for Newsletter Management - NEWLY ADDED */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold text-lime mb-4">Newsletter</h3>
            <p className="text-gray-400 mb-4">Create and send newsletters to all subscribers.</p>
            <button 
              onClick={() => navigate('/admin/newsletter')}
              className="w-full bg-lime text-black font-bold py-2 px-4 rounded-lg hover:bg-opacity-80 transition duration-300">
              Manage Newsletters
            </button>
          </div>
          {/* Card for SEO Management */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold text-lime mb-4">SEO Management</h3>
            <p className="text-gray-400 mb-4">Manage sitewide SEO settings and defaults.</p>
            <button 
              onClick={() => navigate('/admin/seo')}
              className="w-full bg-lime text-black font-bold py-2 px-4 rounded-lg hover:bg-opacity-80 transition duration-300">
              Manage SEO
            </button>
          </div>
           {/* Card for Site Settings */}
          <div className="bg-gray-800 p-6 rounded-lg shadow-lg">
            <h3 className="text-2xl font-bold text-lime mb-4">Site Settings</h3>
            <p className="text-gray-400 mb-4">Configure social media links and site status.</p>
            <button 
              onClick={() => navigate('/admin/settings')}
              className="w-full bg-lime text-black font-bold py-2 px-4 rounded-lg hover:bg-opacity-80 transition duration-300">
              Settings
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}

export default AdminDashboard;
